import { getDatabase, ref, onValue } from "firebase/database";
import firebaseConfigJson from "../firebase.json";
import { initializeApp } from "firebase/app";

class FirebaseSvc {

    constructor() {
      initializeApp(firebaseConfigJson);
      this.database = getDatabase();
    }

    refqw(path = "entries") {
      return ref(this.database, path);
    }

    read = (path, callback, failed_callback) => {
      const reference = this.refqw(path);
      onValue(
        reference,
        snapshot => callback(this.parse(snapshot)),
        failed_callback
      );
    }

    parse = snapshot => {
      const value = snapshot.val();
      return value;
    }
    

}

const firebaseSvc = new FirebaseSvc();
export { firebaseSvc as default };